import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import {
  mapNotificationsViewQuery,
  notificationsViewColumns,
  notificationsSearchSchema,
} from "./NotificationsView.default";
import { getNotifications } from "../repository/data.repository";
import { createGridRequest } from "../hooks/useGridRequest";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";

export interface NotificationsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function NotificationsView(props: NotificationsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={notificationsViewColumns}
      schema={notificationsSearchSchema}
      mapQuery={mapNotificationsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getNotifications, { retry: true })}
      pageSize={100}
      actions={(record) => [
        // A sent notification is read-only (View its delivery summary); a draft can still be edited.
        record.isSent
          ? {
              key: "view",
              label: "View",
              disabled: !permissions.can("Notifications", "view"),
              handler: (key, record) => props.onAction?.(key, record),
            }
          : {
              key: "update",
              label: "Edit",
              disabled: !permissions.can("Notifications", "edit"),
              handler: (key, record) => props.onAction?.(key, record),
            },
        {
          key: "delete",
          label: "Delete",
          disabled: !permissions.can("Notifications", "delete"),
          danger: true,
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default NotificationsView;
